import React, { useEffect, useState } from 'react';
import { api_url } from '../constants';
import axios from 'axios';
import { DataGrid } from '@mui/x-data-grid';
import { CircularProgress, Box, Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Typography, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Paper } from '@mui/material';

const Home = () => {
    const [page, setPage] = useState(0);
    const [posts, setPosts] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [loading, setLoading] = useState(false);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [selectedPostId, setSelectedPostId] = useState(null);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [selectedPost, setSelectedPost] = useState(null);
    const [openDetailsDialog, setOpenDetailsDialog] = useState(false);

    async function fetchPosts() {
        setLoading(true);
        try {
            const response = await axios.get(
                `${api_url}/api/post/listPost?page=${page + 1}&limit=10`
            );
            const sortedPosts = response.data.posts.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
            setPosts(sortedPosts);
            setTotalRows(response.data.totalPages);
        } catch (error) {
            console.error("Failed to fetch posts:", error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchPosts();
    }, [page]);

    const handleOpenDeleteDialog = (id) => {
        setSelectedPostId(id);
        setOpenDeleteDialog(true);
    };

    const handleDelete = async () => {
        if (selectedPostId) {
            setDeleteLoading(true);
            try {
                await axios.delete(`${api_url}/api/post/delete/${selectedPostId}`);
                const response = await axios.get(
                    `${api_url}/api/post/listPost?page=${page + 1}&limit=10`
                );

                setPosts(response.data.posts);
                setTotalRows(response.data.totalPages);
            } catch (error) {
                console.error("Failed to delete post:", error);
            } finally {
                setOpenDeleteDialog(false);
                setSelectedPostId(null);
                setDeleteLoading(false);
            }
        }
    };
    const handleViewClick = (post) => {
        setSelectedPost(post);
        setOpenDetailsDialog(true);
    };
    const handleCloseDetailsDialog = () => {
        setOpenDetailsDialog(false);
        setSelectedPost(null);
    };

    console.log("posts", posts)
    const columns = [
        { field: '_id', headerName: 'ID', width: 100 },
        { field: 'title', headerName: 'Title', width: 100 },
        { field: 'description', headerName: 'Description', width: 250 },
        { field: 'likesCount', headerName: 'Likes', width: 100 },
        { field: 'status', headerName: 'Status', width: 100 },
        {
            field: 'createdAt', headerName: 'Created At', width: 180,
        },
        {
            field: 'photo', headerName: 'Photo', width: 150, renderCell: (params) => (
                <img src={params.value} alt={params.row.title} style={{ width: '100%', objectFit: 'contain' }} />
            )
        },
        {
            field: 'actions', headerName: 'Actions', width: 100, renderCell: (params) => (
                <Box>
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={() => handleOpenDeleteDialog(params.row._id)}
                    >
                        Delete
                    </Button>
                </Box>
            )
        },
        {
            field: 'view', headerName: 'View', width: 100, renderCell: (params) => (
                <Box>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => handleViewClick(params.row)}
                    >
                        View
                    </Button>
                </Box>
            )
        },
    ];

    const handleCloseDeleteDialog = () => {
        setOpenDeleteDialog(false);
        setSelectedPostId(null);
    };

    return (
        <div style={{ height: 600, padding: '0px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            {loading ? (
                <CircularProgress />
            ) : (
                <DataGrid
                    rows={posts ? posts : []}
                    columns={columns}
                    pageSize={10}
                    rowsPerPageOptions={[5, 10, 20]}
                    pagination
                    paginationMode="server"
                    page={page}
                    onPageChange={(params) => setPage(params.page)}
                    rowCount={totalRows}
                    getRowId={(row) => row._id}
                    sortModel={[{ field: 'createdAt', sort: 'desc' }]}
                />
            )}
            <Dialog
                open={openDeleteDialog}
                onClose={handleCloseDeleteDialog}
                aria-labelledby="delete-dialog-title"
                aria-describedby="delete-dialog-description"
            >
                <DialogTitle id="delete-dialog-title">{"Confirm Delete"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="delete-dialog-description">
                        Are you sure you want to delete this post?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDeleteDialog} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleDelete} color="secondary" autoFocus disabled={deleteLoading}>
                        {deleteLoading ? <CircularProgress size={24} /> : "Delete"}
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={openDetailsDialog}
                onClose={handleCloseDetailsDialog}
                aria-labelledby="details-dialog-title"
                aria-describedby="details-dialog-description"
            >
                <DialogTitle id="details-dialog-title">{"Post Details"}</DialogTitle>
                <DialogContent>
                    {selectedPost && (
                        <Box>
                            <TableContainer >
                                <Table>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell>Title</TableCell>
                                            <TableCell>{selectedPost.title}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Description</TableCell>
                                            <TableCell>{selectedPost.description}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Likes</TableCell>
                                            <TableCell>{selectedPost.likesCount}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Status</TableCell>
                                            <TableCell>{selectedPost.status}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Created At</TableCell>
                                            <TableCell>{new Date(selectedPost.createdAt).toLocaleString()}</TableCell>
                                        </TableRow>

                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <Box mt={2}>
                                <img src={selectedPost.photo} alt={selectedPost.title} style={{ width: '100%', objectFit: 'contain' }} />
                            </Box>
                        </Box>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDetailsDialog} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default Home;
